import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import axios from 'axios'

axios.defaults.baseURL = 'http://' + process.env.VUE_APP_API_SERVER_HOST + '/' + process.env.VUE_APP_API_SERVER_URL // main
// axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = "*";
// axios.defaults.withCredentials = true
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.AccessControlAllowCredentials = true;

import VueSimpleWebsocket from "vue-simple-websocket";
// Vue.use(VueSimpleWebsocket, "wss://192.168.10.31:8081", {
// Vue.use(VueSimpleWebsocket, "wss://cab.btcom.kz:17600", {
Vue.use(VueSimpleWebsocket, "ws://cab.btcom.kz:17600", {
    reconnectEnabled: true,
    reconnectInterval: 5000
});
// let connection = new WebSocket("ws://192.168.10.31:7500")
// Vue.use(connection);
// Vue.use(Websocket, {connection_string: 'ws://192.168.10.31', port: '7500'})

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

import VueCountdown from '@chenfengyuan/vue-countdown';

Vue.component(VueCountdown.name, VueCountdown);

// const BUILD_TARGETS = {
//   app: "./App.vue",
//   test: "./Invoice.vue"
// };
//
// const path = BUILD_TARGETS[process.env.VUE_APP_BUILD_TARGET] || "./App.vue";
//
// import(`${path}`).then(({ default: App }) =>
//   new Vue({
//       router,
//       store,
//       render: h => h(App)
//   }).$mount('#app')
// );

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
